import React, { Component } from 'react';
import { Modal, Button } from "react-bootstrap"
import ProjectSelector from './ProjectSelector';

class SelectProjectModal extends Component {

  render() {
    const { isSelectProjectOpen, closeSelectProjectModal,
      projects, projectId,
      platform, contract,
      onProjectChange } = this.props;
    return(
      <Modal aria-labelledby="contained-modal-title-vcenter" centered
        size="lg"
        show={isSelectProjectOpen}
        onHide={closeSelectProjectModal}>
          <Modal.Header closeButton>
            <Modal.Title className="font-display">Select a Project</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <ProjectSelector projects={projects} projectId={projectId} onProjectChange={onProjectChange}/>
          </Modal.Body>
          <Modal.Footer>
            {(contract && contract.options) ? (
              <>
              <Button variant="outline-secondary btn-sm" className="font-display" onClick={() => window.open(`${platform.etherscan_link}${contract.options.address}`)}>etherscan</Button>
              </>
            ) : ("")}
            <Button variant="secondary btn-sm"  className="font-display" onClick={this.closeDetailsModal}>
              close
            </Button>
          </Modal.Footer>
        </Modal>
    );
  }
}

export default SelectProjectModal;
